/**
 * Shuffles an array of n elements (indices 0..n-1) through Fisher-Yates shuffle algorithm.
 * Iterates through an array in the reverse order and swap each element with a random one before it.
 * @param {Array} array
 */
export default function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    const temporaryValue = array[i];
    array[i] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}
